<template>
  <v-container style="max-width: 960px" class="mb-8">
    <v-row>
      <v-col>
        <PageTitle :title="label('title')"/>
      </v-col>
    </v-row>

    <v-row>
      <v-col style="display: flex; justify-content: flex-end">
        <v-btn to="jobs/new" class="mr-2">正社員求人を作成</v-btn>
        <v-btn to="jobs/new?type=side">業務委託求人を作成</v-btn>
      </v-col>
    </v-row>

    <v-row>
      <v-col style="overflow: auto;">
        <v-simple-table style="min-width: 870px;">
          <thead>
            <tr>
              <th style="width: 120px" />
              <th class="pl-6">求人タイトル</th>
              <th class="editedAt text-center">最終公開日</th>
              <th class="status text-center">ステータス</th>
              <th class="text-center" style="width: 80px">公開</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(job, index) of jobs.results" :key="index">
              <td>
                <div class="jobTag" :class="{side: job.isSide}">
                  {{ job.isSide ? '業務委託' : '正社員' }}
                </div>
              </td>
              <td class="my-2">
                <div class="ma-2"><b>{{job.name}}</b></div>
                <div class="ma-2">
                  <TextLink class="mr-2" blue :to="`/clients/jobs/${job.id}/edit`">求人を編集</TextLink>
                  <TextLink class="mx-2" blue :to="clickCopy(job.id, job.isSide)">求人を複製</TextLink>
                  <TextLink class="mr-2" blue :to="`/clients/jobs/${job.id}/draft`">下書きプレビュー</TextLink>
                  <TextLink v-if="showPublicPreview(job)" class="mr-2" blue :to="`/clients/jobs/${job.id}`">公開中プレビュー</TextLink>
                </div>
              </td>
              <td class="period" style="vertical-align: middle;">
                <div class="text-center">
                  {{ publicDate(job) }}&thinsp;
                </div>
              </td>
              <td class="text-center">
                <div :class="statusColor(job.approvalStatus)">
                {{ approvalStatus(job.approvalStatus) }}
                </div>
              </td>
              <td>
                <FlexRow justify="center">
                  <ToggleButton
                      :value="job.isDisclosed"
                      small-label
                      @change="(value) => toggleIsDisclose(job.id, value)"
                  />
                </FlexRow>
              </td>
            </tr>
          </tbody>
        </v-simple-table>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="8" offset="2">
        <Pagination v-model="page" :length="(Math.floor((jobs.count - 1) / 10)) + 1" @change="changePage"/>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import PageTitle from "../../../atoms/PageTitle";
  import ComponentMixin from '../../../ComponentMixin';
  import ApiMixin from "../../../../ApiMixin";
  import { mapGetters } from "vuex";
  import Pagination from "@/components/atoms/Pagination";
  import TextLink from "@/components/atoms/TextLink";
  import ToggleButton from "@/components/atoms/ToggleButton";
  import FlexRow from "../../../atoms/FlexRow";

  export default {
    mixins: [ComponentMixin, ApiMixin],
    type: "page",
    name: "ClientJobTopPage",
    components: {
      FlexRow,
      ToggleButton,
      TextLink,
      Pagination,
      PageTitle,
    },
    data () {
      return {
        page: 1
      }
    },
    computed: {
      ...mapGetters("system", ["consts"]),
      ...mapGetters("user", ["user"]),
      ...mapGetters("client", ["jobs"]),
      approvalStatus () {
        return (status) => {
          if(status == 1) {
            return "公開審査中"
          }
          if(status == 2) {
            return "承認済"
          }
          if(status == 3) {
            return "修正審査中"
          }
          return "未申請"
        }
      },
      showPublicPreview () {
        return (job) => {
          return job.approvalStatus === 2 || job.approvalStatus === 3
        }
      },
      statusColor () {
        return (status) => {
          if (status == 2) {
            return "green--text";
          }
          if (status == 1 || status == 3) {
            return "blue--text"
          }
          return "red--text font-weight-bold";
        }
      },
    },
    beforeMount() {
      if (this.user.id) {
        this.fetchClientJobs();
      }
    },
    methods: {
      fetchClientJobs(page = 1) {
        if (this.user && this.user.business && this.user.business.company) {
          this.page = page;
          this.loadClientJobs(this.user.business.company, page);
        }
      },
      toggleIsDisclose(id, status) {
        this.saveJob(id, {isDisclosed: status}).then(() => {
          // this.fetchClientJobs(this.page);
        })
      },
      clickDetail(id) {
        this.go(`/clients/jobs/${id}`);
      },
      clickEdit(id) {
        this.go(`/clients/jobs/${id}/edit`);
      },
      clickCopy(id,isSide) {
        if(isSide) {
          return `/clients/jobs/new?src=${id}&type=side`
        }
        return `/clients/jobs/new?src=${id}`
      },
      jobValidation(job) {
        return ( !!job.name && !!job.area && !!job.employmentStatus )
      },
      publicDate (job) {
        if (job.approvalStatus < 2) return '-'
        return this.dateToText(job.editedAt)
      },
      changePage (page) {
        this.fetchClientJobs(page);
      },
    },
    watch: {
      "user.id": {
        handler: function(val) {
          if (val) {
            this.fetchClientJobs();
          }
        }
      }
    }
  }
</script>

<style scoped lang="sass">
tr:hover
  background: white !important
th.editedAt
  width: 100px
.status
  width: 120px

.jobTag
  color: white
  font-size: 14px
  font-weight: bold
  line-height: 20px
  text-align: center
  background-color: #CBC74E
  width: 80px
  height: 20px

.jobTag.side
  background-color: #FF5757
</style>
